import { render } from "./VistaDetallePedidoProduccion_origen_productos.vue?vue&type=template&id=3bd2e5dd"
import script from "./VistaDetallePedidoProduccion_origen_productos.vue?vue&type=script&lang=js"
export * from "./VistaDetallePedidoProduccion_origen_productos.vue?vue&type=script&lang=js"

import "./VistaDetallePedidoProduccion_origen_productos.vue?vue&type=style&index=0&id=3bd2e5dd&lang=css"

import exportComponent from "D:\\Users\\felipecedillo\\Documents\\GitHub\\marbel-front\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__